// 引入文案
import enText from './en/index';
import cnText from './cn/index';
// 引入antd国际化
import enUS from 'antd/locale/en_US';
import zhCN from 'antd/locale/zh_CN';
// 引入操作location方法
import { getLanguageKey, setLanguageKey } from 'src/utils/localStorage';
// 引入intl方法
import { createIntl, createIntlCache } from 'react-intl';
// 设置用户语言，默认英文，如果用户存在多语言配置，则取用户配置否则给用户设置上英文
let _currentLang = process.env.REACT_APP_CURRENT_LANG === 'zh-CN' ? 'zh-CN' : 'en';
if (getLanguageKey()) {
  _currentLang = getLanguageKey() as string;
} else if (process.env.REACT_APP_CURRENT_LANG === 'zh-CN') {
  setLanguageKey('zh-CN');
} else {
  setLanguageKey('en');
}
// 设置语言文案
const messages: Record<string, any> = {
  en: enText,
  'zh-CN': cnText
};
// 设置antd语言
export const antdLocale: Record<string, any> = {
  en: enUS,
  'zh-CN': zhCN
};

export const getCurrentLang = () => _currentLang;
export const getCurrentMessages = () => messages[_currentLang];

const cache = createIntlCache();
const intl = createIntl(
  {
    locale: _currentLang,
    messages: getCurrentMessages()
  },
  cache
);

export default intl;
